export enum loadingState {
      initial,
      loading,
      loaded,
      success,
      networkError,
      serverError,
      error,
      hidden
}